import { CircleHelp, Save, Eye } from 'lucide-react';
import { HeaderMenu } from './HeaderMenu';

// ConstructCanvas's supplied codebase is local-first and has no account server.
// Only render sign-in links once an actual deployment provides them.
export function safeAccountUrl(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.trim()) return undefined;
  try {
    const url = new URL(value, window.location.origin);
    if (url.username || url.password) return undefined;
    return url.protocol === 'https:' || (url.origin === window.location.origin && url.protocol === 'http:') ? url.href : undefined;
  } catch { return undefined; }
}

export function ProfileMenu({ onSave, onHelp, onAdChoices }: {
  onSave: () => void; onHelp: () => void; onAdChoices: () => void;
}): JSX.Element {
  const login = safeAccountUrl(import.meta.env.VITE_PROFILE_LOGIN_URL);
  const join = safeAccountUrl(import.meta.env.VITE_PROFILE_JOIN_URL);
  return <HeaderMenu id="profile" className="profile-button" popoverClassName="profile-popover" align="right"
    label={<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><circle cx="12" cy="8" r="4" /><path d="M4.5 21v-2a7.5 7.5 0 0 1 15 0v2" /></svg>} accessibleLabel="User profile">
    <div className="profile-summary" role="presentation">
      <strong>Your account</strong>
      <span>{login ? 'Connect with your account' : 'Local workspace · no account connected'}</span>
      <small>Your model stays in this browser until you save or export it. Download a .ccmodel for a portable backup.</small>
    </div>
    {(login || join) && <>
      <span className="menu-separator" />
      {login && <a href={login} target="_blank" rel="noopener noreferrer">Log in</a>}
      {join && <a href={join} target="_blank" rel="noopener noreferrer">Join</a>}
    </>}
    <span className="menu-separator" />
    <button type="button" onClick={onSave}><Save size={16} />Save .ccmodel</button>
    <button type="button" onClick={onHelp}><CircleHelp size={16} />Help & shortcuts</button>
    <span className="menu-separator" />
    <button type="button" onClick={onAdChoices}><Eye size={16} />Ad choices</button>
    <a href="/privacy.html" target="_blank" rel="noopener noreferrer">Privacy & local data</a>
  </HeaderMenu>;
}
